import styled from 'styled-components';
import React, { useEffect, useMemo } from 'react';
import { EventSource, MessageType } from '../../graphql/graphql';
import { MessageContent } from './MessageContent';
import { MessageIcon } from './MessageIcon';
import { useInView } from 'react-intersection-observer';
import { cssColorValue, semanticBackgroundColors, semanticColors, } from '@spotify-internal/encore-web';
const MessageRowContainer = styled.span `
  width: 80%;
  display: flex;
  justify-content: ${({ isAdvisor }) => (isAdvisor ? 'start' : 'end')};

  align-self: ${({ alignStart }) => (alignStart ? 'start' : 'end')};
  gap: 0.5rem;
`;
export const MessageRow = ({ event, onAttachmentClick, onMessageRowInChatViewport, }) => {
    var _a;
    const alignStart = ((_a = event.messageEvent) === null || _a === void 0 ? void 0 : _a.messageType) === MessageType.Question ||
        event.source === EventSource.Advisor;
    const isAdvisor = event.source === EventSource.Advisor;
    const isMessageWeShouldSendReadMessage = event.source === EventSource.Advisor || event.source === EventSource.Bot;
    const backgroundColor = useMemo(() => cssColorValue(semanticBackgroundColors.backgroundBase), []);
    const foregroundColor = useMemo(() => cssColorValue(semanticColors.textBase), []);
    const [ref, inView] = useInView({ threshold: 0.1 });
    useEffect(() => {
        if (inView && isMessageWeShouldSendReadMessage && !event.readByCustomer) {
            onMessageRowInChatViewport === null || onMessageRowInChatViewport === void 0 ? void 0 : onMessageRowInChatViewport(event.id);
        }
    }, [
        inView,
        isMessageWeShouldSendReadMessage,
        event.readByCustomer,
        event.id,
        onMessageRowInChatViewport,
    ]);
    return (React.createElement(MessageRowContainer, { alignStart: alignStart, isAdvisor: isAdvisor, ref: ref },
        React.createElement(MessageIcon, { event: event, iconColor: backgroundColor }),
        React.createElement(MessageContent, { message: event, onAttachmentClick: onAttachmentClick, primaryBubbleBackgroundColor: backgroundColor, primaryBubbleTextColor: foregroundColor })));
};
